import { render, staticRenderFns } from "./BenchmarkWrapper.vue?vue&type=template&id=0f6626d7&scoped=true"
import script from "./BenchmarkWrapper.vue?vue&type=script&lang=ts"
export * from "./BenchmarkWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6626d7",
  null
  
)

export default component.exports